import React from 'react';
import { useTranslation } from 'react-i18next';
import { useQuery } from 'react-query';

import { http } from 'services';

import * as CertificateModule from 'modules/certificate';
import * as Details from 'components/Details';

import Spinner from 'components/Spinner';
import DownloadV2 from 'components/DownloadV2';

import classes from '../../CertificateVew.module.scss';
import Status from 'components/Status';

interface IProps {
  id: number;
  onClose?: () => void;
}

const ReportView: React.FC<IProps> = ({ id, onClose }) => {
  const { t } = useTranslation();

  const { data, isFetched } = useQuery({
    queryKey: ['report-history', 'single', id],
    queryFn: async () => {
      const { data } = await http.request.get(`/register/register-report/view`, {
        params: {
          id
        }
      });

      return {
        item: CertificateModule.Mappers.reportHistory(data)
      };
    },
    enabled: !!id,
    retry: false
  });

  if (!isFetched) {
    return <Spinner />;
  }

  const colorByStatus = {
    IN_PROGRESS: 'warning',
    REJECT: 'danger',
    SUCCESS: 'success'
  };

  return (
    <div className={classes.reportViewModal}>
      <div className={classes.reportViewModalTitle}>{t('report_response_view_title')}</div>
      <div className={classes.reportViewModalContent}>
        <Details.List className="m-b-24">
          <Details.Item title={t('application_status')}>
            <Status variant={colorByStatus[data?.item.status as keyof typeof colorByStatus]}>
              {t(`report_status_${data?.item.status}`)}
            </Status>
          </Details.Item>
          <Details.Item title={t('report_response_text')}>{data?.item.response_text || '--- --- ---'}</Details.Item>
          <Details.Item title={t('report_response_file')}>
            {data?.item.response_file?.fileId ? (
              <DownloadV2
                fileName={data?.item.response_file?.name}
                downloadApiUrl={`/file/register/download/${data?.item.response_file?.fileId}?register_id=${data?.item.register_id}`}
              />
            ) : (
              '--- --- ---'
            )}
          </Details.Item>
        </Details.List>
      </div>
    </div>
  );
};

export default ReportView;
